import React from 'react';
import { LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Patient, PATIENT_THEME, TalkStatus } from '../../types/patient';
import PatientTableRow from './PatientTableRow';
import { CommonTablePagination } from '../common';

interface PatientTableProps {
  patients: Patient[];
  loading: boolean;
  totalCount: number;
  page: number;
  rowsPerPage: number;
  onChangePage: (event: unknown, newPage: number) => void;
  onChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  searchParams: {
    searchTerm: string;
    emailSearchTerm: string;
    selectedRoles: string[];
    talkStatus: string;
    blockedStatus: string;
    resignedStatus: string;
  };
}

const PatientTable: React.FC<PatientTableProps> = ({
  patients,
  loading,
  totalCount,
  page,
  rowsPerPage,
  onChangePage,
  onChangeRowsPerPage,
  searchParams
}) => {
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      {loading && <LinearProgress/>}
      <TableContainer>
        <Table stickyHeader aria-label="患者一覧">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: PATIENT_THEME.LIST.BACKGROUND,
                  borderBottom: `2px solid ${PATIENT_THEME.LIST.BORDER}`
                }}
              >
                対話状態
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: PATIENT_THEME.LIST.BACKGROUND,
                  borderBottom: `2px solid ${PATIENT_THEME.LIST.BORDER}`
                }}
              >
                ロール
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: PATIENT_THEME.LIST.BACKGROUND,
                  borderBottom: `2px solid ${PATIENT_THEME.LIST.BORDER}`
                }}
              >
                名前 / ニックネーム
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: PATIENT_THEME.LIST.BACKGROUND,
                  borderBottom: `2px solid ${PATIENT_THEME.LIST.BORDER}`
                }}
              >
                性別 (年齢)
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: PATIENT_THEME.LIST.BACKGROUND,
                  borderBottom: `2px solid ${PATIENT_THEME.LIST.BORDER}`
                }}
              >
                がん疾患歴
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: PATIENT_THEME.LIST.BACKGROUND,
                  borderBottom: `2px solid ${PATIENT_THEME.LIST.BORDER}`
                }}
              >
                メールアドレス
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {patients.map((patient) => (
              <PatientTableRow key={patient.id} patient={patient}/>
            ))}
            {patients.length === 0 && !loading && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {searchParams.talkStatus ? (
                    searchParams.talkStatus === TalkStatus.IN_TALK ?
                      '対話中の患者がいません' :
                      '待機中の患者がいません'
                  ) : '患者データがありません'}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CommonTablePagination
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
      />
    </Paper>
  );
};
export default PatientTable;
